export default __webpack_public_path__ + "static/media/p2p-gp-girl.9f536832.webp";